
import type { Session } from '@/api/Sessions'
import SelectAvailableSession from '@/components/events/SelectAvailableSession.vue'
import type { EventDetails } from '@/api/Helpers'
import { conflictingSessions } from '@/helpers/ConflictHelpers'
import environment, { categoriesThatMayConflict } from '@/helpers/Environment'
import { formatSessionList, getHideSoldOutSessionsConfig } from '@/helpers/SessionHelpers'
import { Component, Prop, Vue } from 'vue-property-decorator'
import type { AnnotatedSession } from '@/helpers/DynamicMessages'
import { annotateSession, uniqueAnnotations } from '@/helpers/DynamicMessages'
import DynamicMessageGroup from '@/components/events/DynamicMessageGroup.vue'

/**
 * TODO Use this in <ReserveQuantityFirst>.
 */
@Component({
  name: 'SelectSession',
  components: { DynamicMessageGroup, SelectAvailableSession },
})
export default class extends Vue {
  @Prop({ required: true })
  value: Session | null

  @Prop({ required: true })
  sessions: Session[]

  @Prop({ required: true })
  event: EventDetails

  @Prop({ default: false })
  isAllDayEvent: boolean

  mounted() {
    if (this.availableSessions.length === 1) {
      this.$emit('input', this.availableSessions[0])
    }
  }

  get availableSessions(): AnnotatedSession[] {
    return this._availableSessions.map((session) => annotateSession(session, this.event))
  }

  get _availableSessions(): Session[] {
    const sessions = this.nonSoldOutSessions

    if (this.isAllDayEvent) {
      return sessions
    } else {
      const conflicting = new Set(this.conflictingSessions.map((session) => session.id))
      return sessions.filter((session) => !conflicting.has(session.id))
    }
  }

  get sessionAnnotations(): MessageAction[] {
    return uniqueAnnotations(this.availableSessions)
  }

  get nonSoldOutSessions(): Session[] {
    return this.sessions.filter((session) => !session.sold_out)
  }

  private get conflictingSessions(): Session[] {
    if (categoriesThatMayConflict.has(this.event.category)) {
      return []
    } else {
      return conflictingSessions(
        this.event.id,
        this.event.meta,
        this.nonSoldOutSessions,
        this.$store.getters['Cart/cartItems'],
      )
    }
  }

  get formattedConflictingSessions(): string {
    return formatSessionList(this.conflictingSessions)
  }

  get soldOutSessions(): string {
    return formatSessionList(this.sessions.filter((session) => session.sold_out))
  }

  get showSoldOutTimes(): boolean {
    const hide = getHideSoldOutSessionsConfig(this.event, environment)
    return !hide && this.soldOutSessions.length > 0
  }
}
